import { useCallback, useContext } from 'react';
import type { WorkspaceFileUpload } from '@trinity/chat';
import { TagGeneratingFilesContext } from '@trinity/chat-components/containers/Workspace/context';
import { BaseFileUploadEffectsContainer } from '@trinity/chat-components/containers/WorkspaceFileUpload/Effects.Base.Container';
import { ChatStateDispatchContext } from '../Chat.State/context';

type Props = {
  children: React.ReactNode;
};

export const FileUploadEffectsContainer = (props: Props) => {

  const dispatch = useContext(ChatStateDispatchContext);
  const tagGeneratingContext = useContext(TagGeneratingFilesContext);

  const onComplete = useCallback((data: WorkspaceFileUpload) => {
    dispatch({
      type: 'file-upload-completed',
      payload: {
        identifier: data.uploadIdentifier,
        fileIdentifier: data.identifier,
      },
    });

    // Add file to generating state for tag animation
    if (tagGeneratingContext && data.fileId) {
      tagGeneratingContext.addGeneratingFiles([data.fileId]);
    }
  }, [dispatch, tagGeneratingContext]);

  const onFailure = useCallback((data: WorkspaceFileUpload) => {
    dispatch({
      type: 'file-upload-errored',
      payload: {
        identifier: data.uploadIdentifier,
        fileIdentifier: data.identifier,
      },
    });
  }, [dispatch]);

  const onStart = useCallback((data: WorkspaceFileUpload) => {
    dispatch({
      type: 'file-upload-started',
      payload: {
        identifier: data.uploadIdentifier,
        fileIdentifier: data.identifier,
        fileId: data.fileId,
        fileUploadId: data.id,
      },
    });
  }, [dispatch]);

  return (
    <BaseFileUploadEffectsContainer
      onComplete={onComplete}
      onFailure={onFailure}
      onStart={onStart}>
      {props.children}
    </BaseFileUploadEffectsContainer>
  );
};